
import React, { useState, useCallback, useEffect } from "react";
import { Plus, RefreshCw, Download } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

import AdminLayout from "@/components/Admin/Layout/AdminLayout";
import ModuleLayout from "@/layouts/ModuleLayout";
import EmployeeView from "@/components/Admin/Employee-Management/employeeView";
import { useAuth } from "@/context/AuthContext";
import { P } from "@/config/permissionCodes";

export default function EmployeeManagementPage() {
  const { hasPermission } = useAuth();

  const canAddEmployees = hasPermission(P.HRM.EMPLOYEES.ADD);
  const navigate = useNavigate();
  const location = useLocation();
  const [componentActions, setComponentActions] = useState(null);

  // Detect if accessed from HRM module
  const isHRMRoute = location.pathname.startsWith('/hrm');
  const Layout = isHRMRoute ? ModuleLayout : AdminLayout;

  const handleActionsReady = useCallback((actions) => {
    setComponentActions(actions);
  }, []);

  useEffect(() => {
    if (componentActions?.onRefresh) {
      componentActions.onRefresh();
    }
  }, [componentActions]);

  // Get the base path for navigation (HRM uses 'employees', Admin uses 'employee')
  const employeePath = isHRMRoute ? '/hrm/employees' : '/admin/employee';

  return (
    <Layout>
      <div className="flex flex-col h-full px-6 py-6">
        {/* HEADER */}
        <div className="flex items-center justify-between mb-5">
          <div>
            <h1 className="text-2xl font-bold text-slate-900">
              Employee Directory
            </h1>
            <p className="text-sm text-slate-500">
              Manage and organize your team members
            </p>
          </div>

          <div className="flex items-center gap-2">
            {/* Refresh button */}
            <button
              onClick={componentActions?.onRefresh}
              className="p-2 rounded-lg bg-white border text-slate-600 hover:bg-slate-50"
            >
              <RefreshCw size={16} />
            </button>

            {/* Export */}
            {/* <button className="px-3 py-2 rounded-lg border bg-white hover:bg-slate-50 text-slate-700 flex items-center gap-1 text-sm">
              <Download size={16} />
              Export
            </button> */}

            {/* Add Employee → navigate to new page */}
            {canAddEmployees && (
              <button
              onClick={() => navigate(`${employeePath}/add`)}
              className="px-3 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 flex items-center gap-1.5 text-sm font-medium"
              >
              + Add Employee
              </button>
              )}
          </div>
        </div>

        {/* EMPLOYEE TABLE */}
        <EmployeeView
          renderActions={handleActionsReady}
          onEdit={(item) => navigate(`${employeePath}/edit/${item.id}`)}
        />
      </div>
    </Layout>
  );
}
